import * as actions from "../../../actions/financial/cashFlow";

const initialState = {
  loading: false,
  items: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.GET_CASHFLOW: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_CASHFLOW_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.GET_CASHFLOW_ERROR: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.CLEAR_ITEMS: {
      return {
        ...state,
        items: []
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
